import FinanceXVendorDetail from './FinanceXVendorDetail.component';

export default FinanceXVendorDetail;
